import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useMerchantsListFilterFields } from './hooks/useMerchantsListFilterFields';

export const MerchantsListFilterForm: React.FC = () => {
  const fields = useMerchantsListFilterFields();

  return <FilterFields fields={fields} />;
};
